//interfaces
import { UserActivity } from "@/interfaces/activityFeed";
import { IContentLike } from "@/interfaces/activityFeedNotifications";

//components
import { ActionFeedbackBanner } from "thrive-components";
import ContentTitle from "../../elements/contentTitle/ContentTitle";
import ActivityInformationPanel from "../../elements/activityInformationPanel/ActivityInformationPanel";
import DeletedBanner from "../../elements/deletedComment/DeletedComment";
import ActivityProfileData from "../../elements/activityProfileData/ActivityProfileData";
import ContentLikeTitle from "../../elements/notificationTitle/ContentLikeTitle/ContentLikeTitle";

//hooks
import UseContentLike from "./ContentLike.hooks";

//styling
import "../../../../../css/activityFeed/notifications/content-like-activity.scss";




const ContentLike = ({zIndexNum, isPopOut = false, timeStamp, dateStamp, user, contentAuthor, parentList, content, appDetails, notificationDetails, isRemovedFromParentList, getOpenOnWebLink}: IContentLike) => {
    const {screenClassName, archivedClassName, showFeedbackBanner, feedbackType, feedbackMessage, showDeletedBanner, deletedBannerMessage, webLink, activityInfo} = UseContentLike({isPopOut, timeStamp, dateStamp, parentList, content, appDetails, notificationDetails, isRemovedFromParentList, getOpenOnWebLink})

    return (
        <div className={`${isPopOut ? "" : "content-like-full"} content-like notification-wrapper`}>
            <div className="top-row">
                <ActivityProfileData 
                    imageUrl={user.imageUrl}
                    isPopOut={isPopOut}
                    userActivity={UserActivity.contentLike} 
                    timeStamp={timeStamp}
                    dateStamp={dateStamp}
                />
                
                <ContentLikeTitle 
                    user={user.name} 
                    contentAuthor={contentAuthor?.name} 
                    isPopOut={isPopOut} 
                />
            </div>        

            <ContentTitle 
                zIndexNum={zIndexNum} 
                className={`${screenClassName} ${archivedClassName}`} 
                contentTitle={content.title} 
                getWebLink={webLink} 
            />
            
            {showFeedbackBanner && 
                <ActionFeedbackBanner 
                    feedbackType={feedbackType} 
                    feedbackMessage={feedbackMessage} 
                />
            }
            
            <DeletedBanner 
                isDeleted={showDeletedBanner} 
                message={deletedBannerMessage}
            />

            <ActivityInformationPanel 
                {...activityInfo}
            />
        </div>
    )
};

export default ContentLike